import { gql } from "@apollo/client"

export const RemoteWorkCostsFragment = gql`
  fragment RemoteWorkCostsFragment on Employment {
    availableAllowancePolicies
    remoteWorkCosts {
      equipmentListProvidedByCustomer {
        active
        selectable
        equipmentOther
        equipmentList
        compatibleEquipmentPolicies
        editedAfterCreationFromTemplate
      }
      equipmentListOwnedByTeamMember {
        active
        selectable
        equipmentOther
        equipmentList
        compatibleEquipmentPolicies
        editedAfterCreationFromTemplate
      }
      equipmentBudget {
        active
        selectable
        equipmentBudgetSubunit
        compatibleEquipmentPolicies
        editedAfterCreationFromTemplate
      }
      equipmentOneTimePayment {
        active
        selectable
        equipmentBudgetSubunit
        compatibleEquipmentPolicies
        editedAfterCreationFromTemplate
      }
      allowancePolicy {
        active
        selectable
        isStatutory
        statutoryPolicySubunit
        topUpPolicySubunit
        allowancePolicySubunit
        allowancePolicy
        compatibleEquipmentPolicies
        compatibleAllowancePolicies
        editedAfterCreationFromTemplate
      }
    }
  }
`

export const RemoteWorkCostsTemplateFragment = gql`
  fragment RemoteWorkCostsTemplateFragment on EngagementRemoteWorkCostObjectType {
    equipmentListProvidedByCustomer {
      active
      selectable
      equipmentOther
      equipmentList
      compatibleEquipmentPolicies
    }
    equipmentListOwnedByTeamMember {
      active
      selectable
      equipmentOther
      equipmentList
      compatibleEquipmentPolicies
    }
    equipmentBudget {
      active
      selectable
      equipmentBudgetSubunit
      compatibleEquipmentPolicies
    }
    equipmentOneTimePayment {
      active
      selectable
      equipmentBudgetSubunit
      compatibleEquipmentPolicies
    }
    allowancePolicy {
      active
      selectable
      isStatutory
      statutoryPolicySubunit
      topUpPolicySubunit
      allowancePolicySubunit
      allowancePolicy
      compatibleEquipmentPolicies
      compatibleAllowancePolicies
    }
  }
`
